export const ADD_HEADINGSUBTEXT = 'ADD_HEADINGSUBTEXT';
export function addHeadingSubtext() {
    return {
        type: ADD_HEADINGSUBTEXT,
        headingSubtextObj: { heading: '', subtext: '' }
    }
}

export const UPDATE_HEADING = 'UPDATE_HEADING';
export function updateHeading(text, index) {
    return {
        type: UPDATE_HEADING,
        index,
        text
    }
}

export const UPDATE_SUBTEXT = 'UPDATE_SUBTEXT';
export function updateSubtext(text, index) {
    return {
        type: UPDATE_SUBTEXT,
        index,
        text
    }
}


// WEBPACK FOOTER //
// ./src/App/HeadingSubtext/actions.js